function getRoistatVisit(): string | undefined {
  if (document?.cookie?.includes('roistat_visit')) {
    const visitString = document.cookie.split('; ').find((row) => row.startsWith('roistat_visit'))
    const parts = visitString?.split('=')
    return parts ? parts[1] : undefined
  } else {
    return undefined
  }
}

export {getRoistatVisit}
